import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VideoTutorialesInterface } from '../videos-list';

@Component({
  selector: 'video-grid',
  templateUrl: 'video-grid.component.html',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule]
})
export class VideoGridComponent {
  @Input() videos: VideoTutorialesInterface[] = [];
  @Input() gradientFrom = 'from-indigo-50';
  @Input() gradientTo = 'to-purple-50';

  selectedVideoUrl: SafeResourceUrl | null = null;
  selectedVideoId: string | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  abrirTutorial(link: string) {
    window.open(link, '_blank');
  }

  copiarEnlace(link: string) {
    try {
      navigator.clipboard.writeText(link);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = link;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  }

  verAqui(link: string) {
    const id = this.extraerDriveId(link);
    if (!id) return;
    const embed = `https://drive.google.com/file/d/${id}/preview`;
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    this.selectedVideoId = id;
  }

  cerrarEmbed() {
    this.selectedVideoUrl = null;
    this.selectedVideoId = null;
  }

  expandir(el: HTMLElement) {
    const anyEl = el as any;
    if (anyEl.requestFullscreen) {
      anyEl.requestFullscreen();
    } else if (anyEl.webkitRequestFullscreen) {
      anyEl.webkitRequestFullscreen();
    } else if (anyEl.msRequestFullscreen) {
      anyEl.msRequestFullscreen();
    } else if (anyEl.mozRequestFullScreen) {
      anyEl.mozRequestFullScreen();
    }
  }

  extraerDriveId(url: string): string | null {
    const m1 = url.match(/\/file\/d\/([^/]+)/);
    if (m1 && m1[1]) return m1[1];
    const m2 = url.match(/[?&]id=([^&]+)/);
    if (m2 && m2[1]) return m2[1];
    return null;
  }
}

